import { useBreakpoints } from "@vueuse/core";
import { type Ref } from "vue";

type UseResponsiveReturn = {
  isMobile: Ref<boolean>;
  isTablet: Ref<boolean>;
  isLaptop: Ref<boolean>;
  isDesktop: Ref<boolean>;
  isSmallerThanTablet: Ref<boolean>;
  isSmallerThanLaptop: Ref<boolean>;
  isSmallerThanDesktop?: Ref<boolean>; // Optional, depending on your needs
};

export const useResponsive = (): UseResponsiveReturn => {
  const breakpoints = useBreakpoints({
    mobile: 0, // optional
    tablet: 640,
    laptop: 1024,
    desktop: 1280,
  });

  const activeBreakpoints = {
    isMobile: breakpoints.smaller("tablet"),
    isTablet: breakpoints.between("tablet", "laptop"),
    isLaptop: breakpoints.between("laptop", "desktop"),
    isDesktop: breakpoints.greater("desktop"),
    isSmallerThanTablet: breakpoints.smaller("tablet"),
    isSmallerThanLaptop: breakpoints.smaller("laptop"),
    isSmallerThanDesktop: breakpoints.smaller("desktop"),
  };

  return activeBreakpoints;
};
